import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import patch from './patch';

document.querySelectorAll("[data-pulse-form-id]").forEach(el => {
  const shadowElement = el.shadowRoot.querySelector("[data-shadow-pulse-form-id]");
  if (shadowElement) {
    patch(el);
    const leadFormId = el.getAttribute("data-pulse-form-id");
    const language = navigator.language.split('-')[0] === 'es' ? 'es' : 'en';
    const root = ReactDOM.createRoot(shadowElement);
    root.render(
      <React.StrictMode>
        <App leadFormId={leadFormId} language={language} />
      </React.StrictMode>
    );  
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
